import { ActionList } from '@sparkpost/matchbox';

export default ActionList;
